// Super-admin-only operations that the Firebase client SDK cannot do:
// Cloud Functions deployment health, function logs, and the lead-fanout
// investigation. All proxied through the backend with admin credentials.
import api from "@/lib/api";

export const getFunctions = () => api.get("/admin/functions").then((r) => r.data.functions);
export const getFunctionLogs = (name, limit = 40) =>
  api.get(`/admin/functions/${name}/logs`, { params: { limit } }).then((r) => r.data.entries);
export const investigateRequests = () => api.get("/admin/investigate/requests").then((r) => r.data);
